module.exports = __webpack_public_path__ + "dingbeauty-landing/img/line.7c305654.svg";